import React from 'react'
import { FloatingWhatsApp } from 'react-floating-whatsapp'

export default function App() {

  return (
      <FloatingWhatsApp
        phoneNumber="+542954313911"
        accountName='Colegio Santo Tomas'
        chatMessage='Hola! En que puedo ayudarte?'
        statusMessage='Centro de ayuda'
      />
  )
}